
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import LaunchpadHero from './components/LaunchpadHero';
import ProgramOverview from './components/ProgramOverview';
import ProgramBenefits from './components/ProgramBenefits';
import LaunchpadCTA from './components/LaunchpadCTA';

const PMLaunchpadPage = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <div className="bg-ivory min-h-screen">
      <Navigation />
      
      <main>
        <LaunchpadHero />
        
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 40 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <ProgramOverview />
        </motion.div>
        
        <ProgramBenefits />
        <LaunchpadCTA />
      </main>
      
      <Footer />
    </div>
  );
};

export default PMLaunchpadPage;
